import axios from "axios";
import { environment } from "environment/environment";

const OTM_OPTION_PREMIUM_URL = `${environment.stockApiBaseUrl.replace(
  /\/$/,
  ""
)}/upstox-otm-option-premium`;

const accountRequestConfig = (accountName, config = {}) => ({
  ...config,
  params: {
    ...(config.params || {}),
    accountName,
  },
});

export const fetchUpstoxOtmOptionPremium = (accountName, config) =>
  axios.get(OTM_OPTION_PREMIUM_URL, accountRequestConfig(accountName, config));

export const refreshUpstoxOtmOptionPremium = (accountName, config) =>
  axios.post(
    `${OTM_OPTION_PREMIUM_URL}/refresh`,
    null,
    accountRequestConfig(accountName, config)
  );
